import { useIntl } from "react-intl";

import { ReactComponent as TriangleAlert } from "assets/images/iconsV2/triangle-alert.svg";
import Badge from "components/v2/Badge/Badge";

import "./ValidationErrorBadge.scss";

export default function ValidationErrorBadge() {
  const intl = useIntl();

  return (
    <Badge
      type="category-badge"
      size="sm"
      color="error"
      variant="icon-leading"
      icon={<TriangleAlert className="rfv2-validation-error-badge__icon" />}
      label={intl.formatMessage({
        id: "request-form.validation.requiredFieldsIncomplete",
        defaultMessage: "Required fields are incomplete",
      })}
    />
  );
}
